import firebase from 'firebase'
import 'firebase/firestore'

// firebase init goes here
const config = {
  apiKey: "AIzaSyDRHkoj8ql9d2lVZyRjIUZkICvqkgfUCDQ",
  authDomain: "gazdv-checklist.firebaseapp.com",
  databaseURL: "https://gazdv-checklist.firebaseio.com",
  projectId: "gazdv-checklist",
  storageBucket: "gazdv-checklist.appspot.com",
  messagingSenderId: "1086415800341"
}
firebase.initializeApp(config)

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const currentUser = auth.currentUser

// date issue fix according to firebase
const settings = {
  timestampsInSnapshots: true
}

db.settings(settings)

// firebase collections
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')

export {
  db,
  auth,
  currentUser,
  usersCollection,
  postsCollection,
  commentsCollection,
  likesCollection
}


// WEBPACK FOOTER //
// ./src/firebaseConfig.js